// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cLJ0k6W8AyZ8pYcSrmzz{display:flex;align-items:center;color:#000 !important}.CmXnvJoSjkRBtCEGeC10,.eLgWj0Th5KPTWCyFurfd{color:#000 !important}.eLgWj0Th5KPTWCyFurfd{font-weight:bold}`, "",{"version":3,"sources":["webpack://./src/components/batches/UploadCsvForm/components/FileInfo/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,qBAAA,CACF,4CAEE,qBAAA,CACF,sBACE,gBAAA","sourcesContent":[".file\n  display: flex\n  align-items: center\n  color: #000 !important\n.removeFile,\n.quantity\n  color: #000 !important\n.quantity\n  font-weight: bold\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"file": `cLJ0k6W8AyZ8pYcSrmzz`,
	"removeFile": `CmXnvJoSjkRBtCEGeC10`,
	"quantity": `eLgWj0Th5KPTWCyFurfd`
};
export default ___CSS_LOADER_EXPORT___;
